import { createContext, use } from 'react';

import type { AgentDetailResponse } from '@/types/agent.type';

interface AgentContextType {
  agent: AgentDetailResponse | undefined;
}

const AgentContext = createContext<AgentContextType | undefined>(undefined);

export function AgentProvider({
  children,
  data,
}: {
  children: React.ReactNode;
  data: AgentDetailResponse | undefined;
}) {
  return <AgentContext value={{ agent: data }}>{children}</AgentContext>;
}

export function useAgent() {
  const context = use(AgentContext);
  if (!context) throw new Error('useAgent must be used within AgentProvider');
  return context;
}
